import { type IAgentProfileForBuyerQuery } from 'application/querySchemas/IAgentProfileForBuyerQuery';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import {
    type IAgentProfileForBuyerClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/IAgentProfileForBuyerClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class AgentProfileForBuyerQuery implements IAgentProfileForBuyerQuery {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IAgentProfileForBuyerClient')
        public readonly agentProfileForBuyerClient: IAgentProfileForBuyerClient,
    ) {}

    public async fetch(agentId: number): Promise<IGetResponse['data']> {
        const { data, message } = await this.agentProfileForBuyerClient.get({
            token: this.buyerUserToken.get() || '',
            agent_id: agentId,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
